import { __assign, __rest } from "tslib";
// DS8.2 (!) comes with consts:
export var POPOVER_FOOTER_BUTTON_SIZE = 'medium';
import React from 'react';
import c from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import PopoverRootLayout from '../../layouts/PopoverRootLayout';
import { ThemeOptions, ThemeOverride, } from '@wix/da-react-context/pkg/ThemeContext';
import PopoverHeader from '../../PopoverHeader';
import SpreadLayout from '../../SpreadLayout';
import s from './Popover.scss';
/** Our standard popover.
 *
 * This component is not concerned with placement or show/hiding logic. That's the responsibility of the consumer.
 */
var Popover = function (_a) {
    var heading = _a.heading, headerIllustration = _a.headerIllustration, footerLeft = _a.footerLeft, footerRight = _a.footerRight, className = _a.className, onBackClick = _a.onBackClick, onCloseClick = _a.onCloseClick, _b = _a.matchTheme, matchTheme = _b === void 0 ? false : _b, rest = __rest(_a, ["heading", "headerIllustration", "footerLeft", "footerRight", "className", "onBackClick", "onCloseClick", "matchTheme"]);
    var matchThemeFlag = useFlag('popovers_match_theme');
    return (React.createElement(ThemeOverride, { theme: matchTheme || matchThemeFlag ? 'match' : ThemeOptions.LIGHT },
        React.createElement(PopoverRootLayout, __assign({ className: c(s['root'], className), header: React.createElement(PopoverHeader, { heading: heading, illustration: headerIllustration, onBackClick: onBackClick, onCloseClick: onCloseClick }), footer: footerLeft || footerRight ? (React.createElement(SpreadLayout, { left: footerLeft, right: footerRight })) : undefined }, rest))));
};
Popover.displayName = 'Popover';
export default Popover;
//# sourceMappingURL=Popover.js.map